import { guestColumns } from 'common/list-configs/guest-list.config';

const {
  lastName,
  firstName,
  type,
  validity,
  companyName,
  daysOfWeek,
  keyPermission,
  isShared,
  source,
  dateGuestAdded,
  lastActivityDate,
  restrictions,
  visitDate,
  phone,
  carNumber,
  carState,
  idDocumentImage,
} = guestColumns();
export const guestInitialColumns = [
  lastName,
  firstName,
  companyName,
  type,
  restrictions,
  validity,
  visitDate,
  daysOfWeek,
  keyPermission,
  isShared,
  source,
  dateGuestAdded,
  lastActivityDate,
  phone,
  carNumber,
  carState,
  idDocumentImage,
];
